import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { HeaderComponent } from '@app/components/layout/header/header.component';

/**
 * Layout shell for public routes (no bottom menu).
 * Renders mst-header (fixed top) + router-outlet.
 */
@Component({
    selector: 'mst-layout-public-pages',
    template: `
        <mst-header />
        <div class="mst-layoutPublicPages__content">
            <router-outlet />
        </div>
    `,
    styleUrl: './layout-public-pages.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [HeaderComponent, RouterOutlet],
})
export class LayoutPublicPagesComponent {}
